var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartCrew2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.438,
    height: 33.974,
    viewBox: "0 0 35.438 33.974",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21642",
    "data-name": "\\uADF8\\uB8F9 21642",
    transform: "translate(0.9 0.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10195",
    "data-name": "\\uD328\\uC2A4 10195",
    d: "M511.245,182.217a17.22,17.22,0,0,1-9.288-15.043c.078-8.413,7.111-16.818,16.818-16.818a16.818,16.818,0,0,1,16.818,16.818,17.329,17.329,0,0,1-8.957,14.872",
    transform: "translate(-501.956 -150.355)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_51",
    "data-name": "\\uC120 51",
    y2: 4.265,
    transform: "translate(16.696 0.726)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_52",
    "data-name": "\\uC120 52",
    x2: 8.427,
    y2: 9.351,
    transform: "translate(5.706 4.461)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_53",
    "data-name": "\\uC120 53",
    x1: 4.265,
    transform: "translate(0.754 16.669)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_54",
    "data-name": "\\uC120 54",
    x1: 4.265,
    transform: "translate(28.372 16.669)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_55",
    "data-name": "\\uC120 55",
    x1: 1.129,
    y2: 2.847,
    transform: "translate(9.534 28.552)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_56",
    "data-name": "\\uC120 56",
    x2: 1.129,
    y2: 2.847,
    transform: "translate(23.345 28.552)",
    fill: "#7f47dd",
    stroke: "#adb5bd",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_57",
    "data-name": "\\uC120 57",
    x2: 1.129,
    y2: 2.847,
    transform: "translate(23.345 28.552)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1214",
    "data-name": "\\uD0C0\\uC6D0 1214",
    cx: 2.968,
    cy: 2.968,
    r: 2.968,
    transform: "translate(13.851 13.851)",
    fill: "none",
    stroke: "#adb5bd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartCrew2);
export default __webpack_public_path__ + "static/media/SmartCrew2.ef508749a86e40597514055f40a472e0.svg";
export { ForwardRef as ReactComponent };